export function rangeNumber({ start, end, groupCount = 5 }) {
  const groups = [];
  let group;

  for (let i = start; i <= end; i++) {
    if ((i - start) % groupCount === 0) {
      group = [];
      groups.push(group);
    }
    group.push(i);
  }

  return groups;
}

export function groupList(rawList, parallelCount = 5) {
  const total = rawList.length;
  const groups = [];
  const groupCount = Math.ceil(total / parallelCount);

  for (let i = 0; i < groupCount; i++) {
    groups.push(rawList.slice(i * parallelCount, (i + 1) * parallelCount));
  }

  return groups;
}

export function numberRangeToArray(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

export function isNotEmptyArray(arr) {
  return Array.isArray(arr) && arr.length > 0;
}
